import { gql } from '@apollo/client';
import { TaxCatalogPreflightInfo } from '../fragments';

export default gql`
  query TaxCatalogPreflight {
    taxCatalogPreflight {
      ...TaxCatalogPreflightInfo
    }
  }
  ${TaxCatalogPreflightInfo}
`;
